// src/api/design/meta.js
import api from "../axios";

/** 설계문서 메타 생성 */
export const createMeta = async ({
  project,
  module = "design",
  doc_type = "FCR",
  title = "",
  meta = {},
  level2,
  related_dns = "",
}) => {
  const res = await api.post("/design/meta/", {
    project,
    module,
    title,
    doc_type,
    level2,
    meta,
    related_dns,
  });
  return res.data;
};

/** 설계문서 메타 조회 */
export const getMeta = async ({ dns }) => {
  const res = await api.get("/design/meta/", { params: { dns } });
  return res.data;
};

/** 설계문서 메타 수정(PATCH) */
export const updateMeta = async (dns, payload) => {
  const res = await api.patch("/design/meta/", payload, { params: { dns } });
  return res.data;
};

/** 설계문서 메타 삭제(DELETE) */
export const deleteMeta = async (dns) => {
  const res = await api.delete("/design/meta/", { params: { dns } });
  return res.data;
};

/** FCR/FCN/DCN 메타 목록 */
export const getMetaList = async (params = {}) => {
  const res = await api.get("/design/meta/list", { params });
  return res.data;
};

export const getMetaMyList = async (params = {}) => {
  const res = await api.get("/design/meta/mylist", { params });
  return res.data;
};

export const changeDocState = async (dns, action) => {
  const res = await api.post(`/papers/docs/${dns}/state/`, { action });
  return res.data;
};

export const reapplyDoc = async (dns) => {
  const res = await api.post(`/papers/docs/${dns}/reapply/`);
  return res.data;
};
